import { axiosInstance } from "../../../axios/axiosInstance";

const API_ORGANIZATION_SPONSORSHIP_URL = "admin/organization-top-listing-subscription-plans";
const API_GET_ORGANIZATION_SPONSORSHIP_MODULE_LIST_URL = API_ORGANIZATION_SPONSORSHIP_URL + "/list";
const API_CREATE_ORGANIZATION_SPONSORSHIP_MODULE_URL = API_ORGANIZATION_SPONSORSHIP_URL + "/create";
const API_UPDATE_ORGANIZATION_SPONSORSHIP_MODULE_URL = API_ORGANIZATION_SPONSORSHIP_URL + "/update";
const API_GET_ORGANIZATION_SPONSORSHIP_BY_ID_URL = API_ORGANIZATION_SPONSORSHIP_URL + "/view";

export const getOrganizationTopListingSubscriptionPlan = (dataToBeSent) => {
    return axiosInstance.get(`${API_GET_ORGANIZATION_SPONSORSHIP_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}`);
};

export const createOrganizationSponsorship = (dataToBeSent) => {
    return axiosInstance.post(`${API_CREATE_ORGANIZATION_SPONSORSHIP_MODULE_URL}`, dataToBeSent);
};

export const updateOrganizationSponsorship = (dataToBeSent) => {
    return axiosInstance.post(`${API_UPDATE_ORGANIZATION_SPONSORSHIP_MODULE_URL}/${dataToBeSent?._id}`, dataToBeSent);
};
export const getOrganizationSponsorshipById = (dataToBeSent) => {
    return axiosInstance.get(`${API_GET_ORGANIZATION_SPONSORSHIP_BY_ID_URL}/${dataToBeSent?.selectedOrganizationSponsorshipId}`);
};
